/** Small helpers the event pages share. No components, no queries. */

/** Today in Vienna. For choosing what to show, never for deciding what to accept. */
export function todayInVienna(): string {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "Europe/Vienna",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date());
}

/** "2026-03" a number of months away, without leaving the calendar. */
export function shiftMonth(month: string, delta: number): string {
  const [year, index] = month.split("-").map(Number);
  if (year === undefined || index === undefined) {
    return month;
  }
  const shifted = new Date(Date.UTC(year, index - 1 + delta, 1));
  return shifted.toISOString().slice(0, 7);
}

/** The first and last day of a "YYYY-MM", both inclusive. */
export function monthRange(month: string): { fromDay: string; toDay: string } {
  const [year, index] = month.split("-").map(Number);
  if (year === undefined || index === undefined) {
    return { fromDay: `${month}-01`, toDay: `${month}-31` };
  }
  // Day 0 of the next month is the last day of this one.
  const last = new Date(Date.UTC(year, index, 0));
  return { fromDay: `${month}-01`, toDay: last.toISOString().slice(0, 10) };
}

export function monthLabel(month: string): string {
  const [year, index] = month.split("-").map(Number);
  if (year === undefined || index === undefined) {
    return month;
  }
  return new Intl.DateTimeFormat("en-GB", { month: "long", year: "numeric", timeZone: "UTC" })
    .format(new Date(Date.UTC(year, index - 1, 1)));
}

export function eventKindLabel(kind: string): string {
  switch (kind) {
    case "seminar":
      return "Seminar";
    case "workshop":
      return "Workshop";
    case "instituteDay":
      return "Institute day";
    default:
      return "Event";
  }
}

export function participationRoleLabel(role: string): string {
  switch (role) {
    case "attendee":
      return "Attendee";
    case "speaker":
      return "Talk";
    case "invitedLecturer":
      return "Invited lecture";
    case "posterPresenter":
      return "Poster";
    case "host":
      return "Host";
    case "organiser":
      return "Organiser";
    default:
      return role;
  }
}

export function participationStateLabel(state: string): string {
  switch (state) {
    case "planned":
      return "Coming";
    case "waitlisted":
      return "Waitlisted";
    case "confirmed":
      return "Took part";
    case "noShow":
      return "Did not come";
    case "cancelled":
      return "Withdrawn";
    default:
      return state;
  }
}

export function participationStateColor(state: string): string {
  switch (state) {
    case "confirmed":
      return "green";
    case "planned":
      return "blue";
    case "waitlisted":
      return "orange";
    case "noShow":
      return "red";
    default:
      return "gray";
  }
}

/** Shift a "YYYY-MM-DD" by whole days, matching convex/days.ts. */
export function addDaysLocal(day: string, delta: number): string {
  const [year, month, date] = day.split("-").map(Number);
  if (year === undefined || month === undefined || date === undefined) {
    return day;
  }
  return new Date(Date.UTC(year, month - 1, date + delta)).toISOString().slice(0, 10);
}
